import { useEffect } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import { Link } from "react-router-dom";

export const PageTitle = ({
  title,
  subtitle,
  bgImage,
  showBlur = true,
  showFullImage = false,
}) => {
  useEffect(() => {
    if (!title) return;
    document.title = `${title} | HueHoppers – Joyful Kids' Fashion`;
  }, [title]);

  return (
    <>
      <div
        className="tf-page-title"
        style={{
          backgroundImage: `url(${bgImage.startsWith("http") ? bgImage : `/assets/images/pageBanners/${bgImage}`})`,
          position: "relative",
        }}
      >
        {/* ── Dark overlay ── */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 0,
          }}
        />

        <div
          className="container-full"
          style={{ position: "relative", zIndex: 1 }}
        >
          <div className="heading text-center text_white">
            {title.split(" for ").map((part, i) => (
              <span key={i}>{part}</span>
            ))}
          </div>
          <p className="text-center text-2 text_white mt_5">
            <span
              dangerouslySetInnerHTML={{ __html: subtitle }}
              style={{ display: "block" }}
            />
          </p>
        </div>
      </div>
    </>
  );
};
